import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-layout" }
const _hoisted_3 = { class: "ui-field" }
const _hoisted_4 = { class: "ui-field" }
const _hoisted_5 = {
  key: 1,
  role: "alert",
  class: "ui-alert ui-alert--error mt-4"
}
const _hoisted_6 = {
  key: 0,
  class: "login-divider"
}

import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Spinner } from '@/components/ui/spinner';
import { ArrowRight, ShieldCheck } from '@lucide/vue';

import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
import { useMainStore } from '../store';
import { useRouter, useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useMainStore();

const username = ref('');
const password = ref('');
const message = ref('');
const loading = ref(false);
const mounted = ref(false);
const authMethods = ref<string[]>(['password']);
const oidcLoginUrl = ref<string | null>(null);

const showPasswordLogin = computed(() => authMethods.value.includes('password'));
const showOidcLogin = computed(() => authMethods.value.includes('oidc') && oidcLoginUrl.value);

onMounted(async () => {
  requestAnimationFrame(() => {
    mounted.value = true;
  });

  if (route.query.error === 'oidc') {
    message.value = 'Ошибка входа через SSO';
  }

  try {
    const res = (await axios.get('/api/auth/methods/')).data;
    authMethods.value = res.methods;
    oidcLoginUrl.value = res.oidc_login_url;
  } catch {
    authMethods.value = ['password'];
  }
});

function loginWithOidc() {
  if (!oidcLoginUrl.value) return;

  const next = (route.query.next as string) || '/';
  const params = new URLSearchParams({ next });
  window.location.href = `${oidcLoginUrl.value}?${params.toString()}`;
}

async function login() {
  const data = {
    username: username.value,
    password: password.value,
  };
  loading.value = true;
  try {
    const res = (await axios.post('/api/auth/login/', data)).data;
    store.login({ access: res.access, refresh: res.refresh });
    await store.setCurrentUserName(data.username);

    const next = route.query['next'] as string;
    if (next != null) {
      await router.replace(next);
    } else {
      await router.replace('/');
    }
  } catch (error) {
    message.value = 'Ошибка входа';
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "login-brand" }, [
        _createElementVNode("span", { class: "brand-mark" }, "Q"),
        _createElementVNode("span", null, [
          _createTextVNode(" Quirco "),
          _createElementVNode("span", { class: "brand-secondary" }, "Saas")
        ])
      ], -1)),
      _createVNode(_unref(Card), { class: "login-card" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(CardTitle), { class: "text-2xl" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Войти в аккаунт", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(CardContent), null, {
            default: _withCtx(() => [
              (showPasswordLogin.value)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    class: "space-y-5",
                    onSubmit: _withModifiers(login, ["prevent"])
                  }, [
                    _createElementVNode("label", _hoisted_3, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ui-label" }, "Логин", -1)),
                      _createVNode(_unref(Input), {
                        modelValue: username.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
                        name: "login",
                        autocomplete: "username",
                        placeholder: "Доменное имя",
                        disabled: loading.value,
                        required: "",
                        autofocus: ""
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("label", _hoisted_4, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ui-label" }, "Пароль", -1)),
                      _createVNode(_unref(Input), {
                        id: "password",
                        modelValue: password.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                        name: "password",
                        autocomplete: "current-password",
                        type: "password",
                        placeholder: "Пароль",
                        disabled: loading.value,
                        required: ""
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _createVNode(_unref(Button), {
                      type: "submit",
                      class: "w-full",
                      disabled: !username.value || !password.value || loading.value
                    }, {
                      default: _withCtx(() => [
                        (loading.value)
                          ? (_openBlock(), _createBlock(_unref(Spinner), { key: 0 }))
                          : _createCommentVNode("", true),
                        _cache[5] || (_cache[5] = _createTextVNode(" Войти ", -1)),
                        (!loading.value)
                          ? (_openBlock(), _createBlock(_unref(ArrowRight), {
                              key: 1,
                              size: 16
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ], 32))
                : _createCommentVNode("", true),
              (message.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(message.value), 1))
                : _createCommentVNode("", true),
              (showOidcLogin.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (showPasswordLogin.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("span", null, "или", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      class: "w-full",
                      disabled: loading.value,
                      onClick: loginWithOidc
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ShieldCheck), { size: 17 }),
                        _cache[7] || (_cache[7] = _createTextVNode(" Войти через SSO ", -1))
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})